<template>
    <b-modal ref="modal" size="xl" centered modal-class="sa-modal-table sa-siat-storico-modal" title="Storico stati" ok-only ok-title="Chiudi" @hidden="reset">
        <p v-if="pratica.codice" class="mb-3"><strong>Codice pratica:</strong> {{ pratica.codice }}</p>
        <div class="sa-siat-storico-table-scroll">
            <b-table v-if="items.length > 0" stacked="md" striped :items="items" :fields="fields" :current-page="1" :per-page="perPage" head-variant="light" class="sa-b-table">
                <template #cell(dataOra)="row">
                    {{ row.item.dataOra ? formatDateTime(row.item.dataOra) : "--" }}
                </template>
            </b-table>
            <NoDataComponent v-else title="Nessuno stato storico presente" nome="no-data" subtitle="" icon="fas fa-history" />
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info sa-siat-storico-footer-row">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import toast from "../../../template/layout/utility/sa-toast";
import UtilityMixin from "../../utility/UtilityMixin.js";

export default {
    components: { NoDataComponent },
    mixins: [UtilityMixin],

    data() {
        return {
            pathResource: "/siateventiprestazioniinterventistatistorico",
            pratica: {},
            items: [],
            currentPage: 1,
            perPage: 50,
            rows: 0,
            fields: [
                { label: "Stato", key: "stato" },
                { label: "Creato da", key: "createUser" },
                { label: "Data e ora", key: "dataOra" },
            ],
        };
    },
    watch: {
        currentPage: function () {
            if (this.pratica.eventiPrestazioniIntevalliBean) {
                this.loadData();
            }
        },
    },
    methods: {
        show(pratica) {
            let intervento = pratica.eventiPrestazioniIntevalliBean;
            if (!intervento || !intervento.id) {
                return;
            }
            this.pratica = pratica;
            this.items = [];
            this.rows = 0;
            this.currentPage = 1;
            this.$refs.modal.show();
            this.loadData();
        },
        loadData() {
            let intervento = this.pratica.eventiPrestazioniIntevalliBean;
            let filtroPraticheStoricoSiat = {
                idPrestazioniInterventi: intervento.id,
                forPage: this.perPage,
                page: this.currentPage,
            };
            this.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(this.pathResource, filtroPraticheStoricoSiat, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            let data = response.data && response.data.data ? response.data.data : {};
            this.items = Array.isArray(data.list) ? data.list : [];
            this.rows = data.recordsNumber != null ? data.recordsNumber : this.items.length;
            this.$emit("afterLoadData");
        },
        loadDataError() {
            this.items = [];
            this.rows = 0;
            this.$emit("afterLoadData");
            toast.error("Errore durante il caricamento dello storico stati");
        },
        reset() {
            this.pratica = {};
            this.items = [];
            this.rows = 0;
            this.currentPage = 1;
        },
    },
};
</script>

<style scoped>
.sa-siat-storico-table-scroll {
    max-height: 300px;
    max-height: min(300px, 40vh);
    overflow-y: auto;
}

.sa-siat-storico-footer-row {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.sa-siat-storico-table-scroll ::v-deep .sa-b-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
}
</style>
